import { IsBoolean, IsDefined, IsInt, IsNotEmpty, IsOptional, IsString, Length, IsArray, ArrayMinSize, IsNumber } from 'class-validator';
import { MembershipTypeDto } from './membershipType.dto';

/**
 * DTO object for creation of Brand Membership Type.
 */
export class MembershipTypeCreateDto extends MembershipTypeDto {
  @IsDefined()
  @IsString()
  @IsNotEmpty()
  @Length(0, 150)
  name: string;

  @IsOptional()
  @IsString()
  @Length(0, 255)
  photoUrl: string;

  @IsOptional()
  @IsString()
  @Length(0, 255)
  description: string;

  @IsDefined()
  @IsBoolean()
  active: boolean;

  @IsDefined()
  @IsInt()
  brandId: number;

  @IsOptional()
  @IsNumber()
  discountTypeId: number;

  @IsDefined()
  @IsArray()
  @ArrayMinSize(1)
  @IsNumber({}, { each: true })
  merchants: number[];
}
